import { render } from "./FlashSaleProductsComponent.vue?vue&type=template&id=18c71991"
import script from "./FlashSaleProductsComponent.vue?vue&type=script&lang=js"
export * from "./FlashSaleProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/FlashSaleProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c71991"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c71991', __exports__)) {
    api.reload('18c71991', __exports__)
  }
  
  module.hot.accept("./FlashSaleProductsComponent.vue?vue&type=template&id=18c71991", () => {
    api.rerender('18c71991', render)
  })

}


export default __exports__